export enum OFFER_CARD_COLORS {
  'blue' = 'blue',
  'green' = 'green',
  'red' = 'red',
  'cyan' = 'cyan',
}

type TOfferCardColorMap = {
  [key in OFFER_CARD_COLORS]: {
    bg: string;
    text: string;
    border: string;
  };
};

export const OFFER_CARD_COLOR_MAP: TOfferCardColorMap = {
  blue: {
    bg: 'bg-blue-100',
    text: 'text-blue-300',
    border: 'border-blue-300',
  },
  green: {
    bg: 'bg-green-100',
    text: 'text-green-300',
    border: 'border-green-300',
  },
  red: {
    bg: 'bg-red-100',
    text: 'text-red-300',
    border: 'border-red-300',
  },
  cyan: {
    bg: 'bg-cyan-100',
    text: 'text-cyan-300',
    border: 'border-cyan-300',
  },
};
